//  react_frontend/src/Components/Router/StrictPublicRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function StrictPublicRoute({ children }) {
  const token = localStorage.getItem("token");
  const location = useLocation();

  // ✅ If user is logged in and trying to access login/register, redirect to dashboard
  if (token && (location.pathname === "/" || location.pathname === "/company-register")) {
    return <Navigate to="/dashboard" replace />;
  }

  // ✅ If user is not logged in, allow access to public page
  return children;
}
